import { useCart } from '@eliadmin/core/src/hooks/cart/use-cart';
import {
  useConfiguratorStore,
  useProformQuery,
} from '@eliadmin/core/src/stores/configurator-store';
import { buildProductCode } from '@eliadmin/core/src/utils/proform-utils';

export function useCartPresence(cartHash?: string | null) {
  const confId = useConfiguratorStore(s => s.user_konf_id);
  const editCartHash = useConfiguratorStore(s => s.cart_hash);
  const { data: productConfId } = useProformQuery('GET_PRODUCT_CONF_ID', {
    user_konf_id: confId,
  });
  const cart = useCart();

  const cartItems = cart.data?.items ?? [];
  const stableCartHash = cartHash ?? editCartHash;
  const cartItemByHash = stableCartHash
    ? cartItems.find(item => String(item.hash) === String(stableCartHash))
    : undefined;

  if (cartItemByHash) {
    return cartItemByHash;
  }

  const cartItem = cartItems.find(
    item =>
      item.code ===
      buildProductCode(productConfId.root.smako_conf.column.cislo_nomenklatury, confId),
  );

  return cartItem;
}
